import { get } from '@/utils';

// Răspunsul BE (api/info) folosește chei lowercase: { version, environment, uptime, buildDate }.
export interface BackendInfo {
	version: string;
	environment: string;
	uptime?: string;
	buildDate: string;
}

const pick = (raw: Record<string, unknown>, ...keys: string[]): string | undefined => {
	const key = keys.find((k) => raw[k] !== undefined && raw[k] !== null);
	return key ? String(raw[key]) : undefined;
};

export const fetchBackendInfo = async (): Promise<BackendInfo> => {
	const response = await get('api/info');
	const raw = (response.data ?? {}) as Record<string, unknown>;
	return {
		version: pick(raw, 'version', 'Version') ?? '',
		environment: pick(raw, 'environment', 'Environment') ?? '',
		uptime: pick(raw, 'uptime', 'Uptime'),
		buildDate: pick(raw, 'buildDate', 'BuildDate') ?? ''
	};
};
